import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

const AdminLogin = () => {
    const { login, user } = useAuth();
    const [email, setEmail] = useState("admin@backatone.com");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();
    const loc = useLocation();

    useEffect(() => {
        if (user && user !== false) {
            nav("/admin/dashboard", { replace: true });
        }
    }, [user, nav]);

    const submit = async (e) => {
        e.preventDefault();
        try {
            setBusy(true);
            await login(email, password);
            const to = loc.state?.from?.pathname || "/admin/dashboard";
            nav(to, { replace: true });
        } catch (err) {
            const msg = err.response?.data?.detail || "Login failed";
            toast.error(typeof msg === "string" ? msg : "Login failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-white" data-testid="admin-login-page">
            <div className="hidden lg:flex flex-col justify-between bg-gray-900 text-white p-12">
                <Logo variant="dark" className="h-12" />
                <div>
                    <div className="overline text-red-600 mb-4">Admin Console</div>
                    <h1 className="font-display font-black uppercase tracking-tighter text-5xl leading-none">
                        Manage your<br />catalog &amp;<br /><span className="text-red-600">inquiries.</span>
                    </h1>
                    <p className="text-gray-400 mt-6 max-w-sm">
                        Sign in to edit machinery, upload photos, update descriptions and respond to leads.
                    </p>
                </div>
                <div className="font-mono text-xs uppercase tracking-[0.22em] text-gray-500">
                    © {new Date().getFullYear()} Back At One · Engineering
                </div>
            </div>

            <div className="flex items-center justify-center p-8 md:p-12">
                <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
                    <div className="overline text-red-600 mb-3">Secure Sign-In</div>
                    <h2 className="font-display font-black uppercase tracking-tight text-3xl md:text-4xl mb-10">Welcome back.</h2>

                    <label className="label-mono">Email</label>
                    <input
                        className="input-field"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid="admin-email-input"
                        autoComplete="email"
                    />
                    <div className="h-5" />
                    <label className="label-mono">Password</label>
                    <input
                        className="input-field"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        data-testid="admin-password-input"
                        autoComplete="current-password"
                    />

                    <button type="submit" disabled={busy} className="btn-primary mt-10 w-full justify-center" data-testid="admin-login-submit">
                        <Lock size={14} /> {busy ? "Signing In…" : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
